import { produce } from "immer";
import {
  SET_DEFINITION,
  SET_DEFINITIONS,
} from "./actions";
import { COMMIT_SELECTIONS } from "state/selections/actions";
import SelectionState from "state/selections/SelectionState";

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
};

export default produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      const { definition, idx } = action;
      const selectedDefinitions = state.definitions[SelectionState.UNCOMMITTED];
      if (definition === null) {
        selectedDefinitions.splice(idx, 1);
      } else {
        selectedDefinitions[idx] = definition;
      }
      break;
    }

    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }
    case COMMIT_SELECTIONS: {
      state.analyticsData = defaultState.analyticsData;
      state.definitions[SelectionState.COMMITTED] = state.definitions[SelectionState.UNCOMMITTED];
      break;
    }

    default:
      return state;
  }
});
